import classNames from 'classnames';

interface SpinnerSmallProps {
  dark?: boolean;
  className?: string;
}

function SpinnerSmall({ dark = false, className }: SpinnerSmallProps) {
  return (
    <div className={classNames('', 'w-4', className)}>
      <svg
        className="animate-spin"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="loader-circle">
          <path
            id="Vector"
            d="M18 9.99988C17.9999 11.5837 17.4984 13.1268 16.5674 14.4081C15.6364 15.6895 14.3237 16.6431 12.8174 17.1325C11.3111 17.6219 9.6885 17.6218 8.1822 17.1324C6.67591 16.6429 5.36323 15.6892 4.4323 14.4078C3.50138 13.1265 2.99999 11.5833 3 9.99946C3.00001 8.41563 3.50142 6.87247 4.43237 5.59113C5.36331 4.30979 6.676 3.35605 8.1823 2.86661C9.6886 2.37717 11.3112 2.37715 12.8175 2.86655"
            stroke={dark ? 'black' : 'white'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </div>
  );
}

export default SpinnerSmall;
